// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ed803065","453":"615aea37","455":"8d4ff3a6"}[chunkId] + ".chunk.js";
};